<template>
  <div class="bill">
    <div class="card info">
      <div class="title">{{ insuranceName }}</div>
      <div
        class="mark"
        :style="{ backgroundImage: background.backgroundImage2 }"
      >
        <div>保险要求:</div>
        <div class="desc" v-html="insuranceDesc"></div>
      </div>
    </div>

    <div class="card form">
      <div class="title">填写信息</div>

      <van-cell-group>
        <van-field
          readonly
          clickable
          label="保单生效时间"
          placeholder="请选择保险保障时间"
          right-icon="arrow"
          input-align="right"
          :value="date"
          @click="showCalendar = true"
          class="form1"
        >
          <template #right-icon>
            <img class="edit_right_icon" src="./img/edit_icon.png" />
          </template>
        </van-field>
        <van-calendar
          v-model="showCalendar"
          :default-date="defaultDate"
          type="range"
          @confirm="onConfirm"
          :min-date="new Date(2000, 1, 1)"
          :max-date="new Date(2099, 1, 1)"
        />

        <van-field
          label="保险公司名称"
          placeholder="请输入不超10个字的名称"
          maxlength="10"
          input-align="right"
          v-model="uploadInfo.insuranceCompanyName"
        />

        <van-cell class="form3">
          <template #title>
            <div>
              请上传符合要求的保单
              <span>(不超过6张)</span>
            </div>
          </template>
          <template #right-icon>
            <!-- <span style="color: #ff1d1d">查看示例</span> -->
          </template>
        </van-cell>

        <van-cell>
          <van-uploader
            v-model="fileList"
            multiple
            :max-count="6"
            :after-read="afterRead"
            upload-text="上传照片"
          />
        </van-cell>
      </van-cell-group>
    </div>

    <!-- <div class="submit" @click="handleSubmit">提交</div> -->
    <div class="foot">
      <van-button
        @click="handleSubmit"
        class="submit-btn"
        type="primary"
        block
        loading-type="spinner"
        :loading="loading"
        loading-text="提交中..."
        >提交</van-button
      >
    </div>
  </div>
</template>
<script>
import { CellGroup, Field, Calendar, Uploader } from 'vant';
import moment from 'moment';
import { uploadFile } from '@/api/accusation';
import { ApiGetInsurUpload, ApiGetInsurDetail } from '@/api/insurance';

export default {
  name: 'insure_edit',
  components: {
    VanCellGroup: CellGroup,
    VanField: Field,
    VanCalendar: Calendar,
    VanUploader: Uploader,
  },
  computed: {
    plazaId() {
      return this.$store.state.account.plazaId;
    },
    plazaName() {
      return this.$store.state.account.plazaName;
    },
    storeId() {
      return this.$store.state.account.storeId;
    },

    storeName() {
      return this.$store.state.base.storeName;
    },
    bunkDesc() {
      return this.$store.state.base.bunkDesc;
    },

    insuranceId() {
      return this.$route.query.insuranceId;
    },
    insuranceName() {
      return this.$route.query.insuranceName;
    },
    insuranceDesc() {
      return this.$route.query.insuranceDesc;
    },
  },
  data() {
    return {
      background: {
        backgroundImage2: 'url(' + require('./img/edit_img.png') + ')',
      },
      showCalendar: false,
      defaultDate: [new Date()],
      date: '',
      fileList: [],
      uploadInfo: {
        startDate: '',
        endDate: '',
        insuranceCompanyName: '',
        picUrl: '',
        source: 1,
        uploadIdentity: 0,
      },
      loading: false,
      id: '',
    };
  },
  methods: {
    formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.showCalendar = false;
      this.date = `${moment(start).format('YYYY.MM.DD')} - ${moment(end).format(
        'YYYY.MM.DD'
      )}`;
      this.uploadInfo.startDate = moment(start).format('YYYY-MM-DD');
      this.uploadInfo.endDate = moment(end).format('YYYY-MM-DD');
    },
    afterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let formData = new FormData();
      formData.set('path', 'insure');
      formData.append('files', file.file);

      let length = this.fileList.length;
      let item = this.fileList[length - 1];

      uploadFile(formData).then((res) => {
        file.status = 'done';
        let url = res.imageVOs[0].url;
        this.fileList.splice(length - 1, 1, { ...item, url });
      });
    },

    handleSubmit() {
      if (!this.uploadInfo.startDate) return this.$toast('请填写保单生效时间');
      if (!this.uploadInfo.insuranceCompanyName)
        return this.$toast('请填写保险公司名称');
      if (!this.fileList.length) return this.$toast('请上传保单照片');

      this.loading = true;
      let picUrl = this.fileList.map((el) => el.url).join(',');
      if(picUrl.length < 10){
        return this.$toast('保单照片错误');
      }

      let data = {
        ...this.uploadInfo,
        id: this.id,
        insuranceId: this.insuranceId,
        insuranceName: this.insuranceName,
        picUrl,
        plazaId: this.plazaId,
        plazaName: this.plazaName,
        storeId: this.storeId,
        storeName: this.storeName,
        bunkDesc: this.bunkDesc,
      };
      if (!data.id) delete data.id;

      ApiGetInsurUpload(data).then((res) => {
        this.loading = false;
        if (res.status != 200) {
          return this.$toast.fail(res.message);
        }
        this.$toast.success('上传成功');

        setTimeout(() => {
          this.$router.go(-1);
        }, 1500);
      });
    },
  },

  mounted() {
    let { id } = this.$route.query;

    if (id) {
      this.id = id;
    }
  },

  activated() {
    console.log(1);
    // 在首次挂载、
    // 以及每次从缓存中被重新插入的时候调用
  },
  deactivated() {
    console.log(2);
    // 在从 DOM 上移除、进入缓存
    // 以及组件卸载时调用
  },
};
</script>

<style lang="less" scoped>
.bill {
  background: #f3f5f6;
  padding: 12px;
  text-align: left;
  line-height: 1;
  overflow: auto;
  box-sizing: border-box;
  font-family: PingFangSC-Medium, PingFang SC;
  padding-bottom: 80px;
  .card {
    background: #ffffff;
    border-radius: 8px;
    padding: 16px 12px 12px 12px;
    .title {
      font-size: 16px;
      font-weight: 500;
      color: #111111;
      margin-bottom: 12px;
    }
  }
  .info {
    .mark {
      background: #fff3f3;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      padding: 8px;
      border-radius: 8px;
      white-space: pre-line;

      background-position: right bottom;
      background-repeat: no-repeat;
      background-size: 60px 59px;
    }
  }
  .form {
    .van-hairline--top-bottom::after {
      border: none;
    }
    margin-top: 12px;
    .van-cell {
      padding-left: 0;
      padding-right: 0;
    }
    .van-cell::after {
      left: 0;
      right: 0;
    }
    /deep/.van-cell__title {
      color: #666666;
    }

    /deep/.van-cell__value {
      overflow: unset;
    }
    .form3::after {
      display: none;
    }
    .van-uploader {
      /deep/.van-uploader__upload {
        border-radius: 6px;
        background-color: #f5f5f5;
        width: 100px;
        height: 100px;
      }
      /deep/.van-icon-photograph {
        font-size: 34px;
      }
      /deep/.van-uploader__upload-text {
        margin-top: 0;
      }

      /deep/.van-uploader__preview-image {
        width: 100px;
        height: 100px;
      }

      /deep/.van-image__img {
        border-radius: 8px;
      }
      /deep/.van-uploader__preview-delete {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        top: -4px;
        right: -4px;
      }
      /deep/.van-uploader__preview-delete-icon {

        font-size: 12px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    /deep/.van-field__control--right {
      font-weight: 700;
    }
    /deep/.van-field__control--right::placeholder {
      font-weight: 100;
    }
    /deep/.van-field__label {
      font-weight: 100;
    }

    .edit_right_icon {
      vertical-align: middle;
      width: 8px;
      height: 14px;
    }
  }
  .foot {
    position: fixed;
    bottom: 12px;
    left: 12px;
    right: 12px;

    .submit-btn {
      height: 44px;
      line-height: 44px;
      background: linear-gradient(270deg, #ff8366 0%, #ff1d1d 100%);
      border-radius: 22px;
      text-align: center;
      color: #fff;
      font-size: 18px;
      font-weight: 500;
      border: none;
      color: #ffffff;
    }
  }
}
</style>